import categoriesService from '../../services/categoriesService'

class CategoriesController {
  fetchCategories = categoriesService.fetchCategories
}

export default new CategoriesController()
 


// WEBPACK FOOTER //
// ../src/controllers/categoriesController/categoriesController.js